export enum CreationRenderTypeEnum {
  Page = 'page',
  Modal = 'modal',
  Panel = 'panel',
}
